export const parkChannelIdSelector = (state) => state.park.channelId;
export const parkIdSelector = (state) => state.park?.parkId;
export const selectedDateSelector = (state) => state.park.selectedDate;
